// extracted by mini-css-extract-plugin
export default {"control":"Mxyq1_9n7a"};